<script>
import Translatable from '@src/mixins/translatable.js'
import { required, email } from 'vuelidate/lib/validators'

export default {
  validations: {
    email: {
      email,
      required
    },
  },
  mixins: [
    Translatable,
  ],
  data() {
    return {
      email: '',

      subscription: false,
      isOutside: false,
    }
  },
  methods: {
    handleFocusOut() {
      this.isOutside = true
    },
    subscribe() {
      if (this.$v.$invalid) {
        this.isOutside = true
        this.$v.$touch()
      } else {
        this.$store.dispatch('reviews/subscribeEmail', this.email)
        this.subscription = !this.subscription
      }
    }
  },
}
</script>

<template>
  <div class="main-container" >
    <div class="description-container">
      <p class="description-title" v-html="getTranslatedContent('CONTACT_US_stay_in_touch_form_title')"></p>
      <p class="description-text" v-html="getTranslatedContent('CONTACT_US_stay_in_touch_form_text')"></p>
    </div>
    <div class="inputs-container">
      <div v-if="subscription" class="sub-container">
        <p class="sub-text">{{ getTranslatedContent('CONTACT_US_thank_you') }}</p>
      </div>
      <div v-else class="content-container">
        <div class="input-container">
          <label for="emailAdress" class="input-title">
            <div class="input-title-container">
              <p class="input-title">{{ getTranslatedContent('CONTACT_US_form_email_field') }}</p>
              <p v-if="$v.email.$error && !$v.email.required" class="error-message">{{ getTranslatedContent('FORM_validate_required') }}</p>
              <p v-if="!$v.email.email && isOutside" class="error-message">{{ getTranslatedContent('FORM_validate_email') }}</p>
            </div>
            <input
              id="emailAdress"
              v-model="$v.email.$model"
              type="email"
              :placeholder="getTranslatedContent('CONTACT_US_get_in_touch_form_placeholder')"
              :class="$v.email.$error && isOutside ? 'error' : ''"
              @focusout="handleFocusOut"
            >
          </label>
        </div>
        <div class="button-container">
          <button class="button-send" @click="subscribe">{{ getTranslatedContent('CONTACT_US_sign_up') }}</button>
        </div>
      </div>
      <div class="content-container">
        <div class="input-container">
          <p class="content-title" v-html="getTranslatedContent('CONTACT_US_office_title')"></p>
          <p class="content-text" v-html="getTranslatedContent('CONTACT_US_office_address')"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.main-container {
  background-color: $white;
  width: 1140px;
  margin-top: 78px;
}

.description-container {
  width: 100%;
  margin-bottom: 30px;

  .description-title {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 22px;
    line-height: 130%;
    color: $dark-blue;
    padding-bottom: 15px;
  }

  .description-text {
    font-family: Open Sans, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 165%;
    color: $black;
  }
}

.content-container, .sub-container {
  display: flex;
  margin: 0 90px 5px 0;

  .content-title {
    font-family: Open Sans, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: $dark-blue;
    padding-bottom: 15px;
    color: rgba(37, 44, 62, 0.6)
  }

  .content-text, .sub-text{
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 18px;
    color: $black;
  }
}

.sub-container {
  min-width: 446px;
  align-items: center;
}

.input-title-container {
  display: flex;
}

.inputs-container {
  display: flex;

  .input-container {
    height: 76px;
    margin-right: 7px;
    min-width: 333px;
  }

  .input-title {
    display: flex;
    flex-direction: column;
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 130%;
    color: $dark-blue;
  }
}

.input-container input {
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  border: 1px solid $dark-gray;
  border-radius: 5px;
  padding: 15px;
  margin-top: 10px;
  background: $white;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: rgba(37, 44, 62, 0.6);
}

::placeholder {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  line-height: 130%;
  color: rgba(37, 44, 62, 0.6);
}

.button-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding-top: 26px;
}

.button-send {
  min-width: 106px;
  height: 48px;
  background: $orange;
  border-radius: 5px;
  border: 1px solid $orange;
  text-transform: uppercase;
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 130%;
  color: $white;
  white-space: nowrap;
  padding: 0 20px;

  &:hover {
    border: 1px solid $hover-orange;
    background: $hover-orange;
  }
}

.error-message {
  display: inline;
  font-family: Open Sans Semibold;
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  text-transform: lowercase;
  color: $orange;
  margin-left: 10px;
}

.error {
  border: 1px solid $orange !important;
}

@media only screen and (max-width: $screen-width-xs) {
  .main-container {
    width: auto;
    margin-top: 40px;
  }

  .content-container {
    flex-direction: column;
    width: 100%;
    margin-bottom: 20px;

    .content-title {
      padding-bottom: 5px;
    }
  }

  .description-container {
    width: 100%;
    margin-bottom: 38px;

    .description-title {
      font-size: 18px;
    }

    .description-text {
      opacity: 1;
    }
  }

  .inputs-container {
    display: flex;
    flex-direction: column;

    .input-container {
      min-width: 100%;
    }

    .input-title {
      font-family: Open Sans Bold, sans-serif;
      font-weight: bold;
    }
  }

  .button-container{
    padding-top: 15px;
  }

  .button-send {
    width: 100%;
  }

  .sub-container {
    margin-bottom: 30px;
  }
}
</style>
